import React, { useContext, forwardRef } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { ThemeContext } from "../Theme";

import styles from "./CopyText.scss";

export const CopyTextDefaultTagName = "p";

// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
export const CopyText = forwardRef(
  (
    { children, variants, tag: CustomTag, customClass, ...elementProps },
    ref
  ) => {
    const context = useContext(ThemeContext);

    const elementClasses = cx(variants, customClass, {
      [styles.copyText]: !variants,
      [styles[context]]: context,
    });

    return (
      <CustomTag className={elementClasses} ref={ref} {...elementProps}>
        {children}
      </CustomTag>
    );
  }
);

CopyText.Variant = {
  additional: styles.additional,
  highlight: styles.highlight,
  legibility: styles.legibility,
  magenta: styles.magenta,
  themeDark: "copy-text--theme_dark",
};

CopyText.propTypes = {
  tag: PropTypes.string,
  variants: PropTypes.oneOfType([
    PropTypes.oneOf([
      "",
      CopyText.Variant.additional,
      CopyText.Variant.highlight,
      CopyText.Variant.legibility,
      CopyText.Variant.magenta,
    ]),
    PropTypes.arrayOf(
      PropTypes.oneOf([
        CopyText.Variant.additional,
        CopyText.Variant.highlight,
        CopyText.Variant.legibility,
        CopyText.Variant.magenta,
      ])
    ),
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  customClass: PropTypes.string,
};

CopyText.defaultProps = {
  tag: CopyTextDefaultTagName,
  variants: "",
  customClass: undefined,
};

CopyText.displayName = "CopyText";

export default CopyText;
